import { render, staticRenderFns } from "./ListadoComponent.vue?vue&type=template&id=2fde4c7c&scoped=true&"
import script from "./ListadoComponent.vue?vue&type=script&lang=ts&"
export * from "./ListadoComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ListadoComponent.vue?vue&type=style&index=0&id=2fde4c7c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fde4c7c",
  null
  
)

export default component.exports